export type TStatus =
  | 'OPEN'
  | 'IN PROGRESS'
  | 'PENDING'
  | 'RESOLVED'
  | 'CLOSED'
  | 'CANCELLED'
  | 'ABANDONED'
  | 'AWAITING_SALESFORCE_TICKET_CREATION'

export enum EStatus {
  OPEN = 'Open',
  'IN PROGRESS' = 'In Progress',
  PENDING = 'Pending',
  RESOLVED = 'Resolved',
  CLOSED = 'Closed',
  CANCELLED = 'Cancelled',
  ABANDONED = 'Abandoned',
  AWAITING = 'Awaiting_Salesforce_Ticket_Creation',
}

export type TFile = {
  name: string
  size: number
  type: string
  s3Uri?: string
  uploadedAt: string
}

export type TServiceData = {
  owner?: string
  subject: string
  details: string
  status: TStatus
  openingDate: string
  updatedAt: string
  lastSeen: string
  protocol: string
  hasUpdate?: boolean
  externalId: string
  caseId?: string
  areaResponse?: string
  additionalInfo?: string
  pendingReason?: string
  ticketFiles?: TFile[]
}

export type TSignalType = 'gray' | 'orange' | 'turquoise' | 'success' | 'warning' | 'error'

export type TTagType = 'green' | 'yellow' | 'gray' | 'red' | 'orange' | 'turquoise'

export type TFilterDictionary = {
  COMPLETED: string
  UNDER_REVIEW: string
  CANCELED: string
  ALL: string
  AWAITING: string
}
